<template>
  <f-group :label="label" :id="id" :required="required" :tooltip="tooltip" :error="error">
    <textarea
      :class="['form-control', error && 'is-invalid']"
      :id="id"
      :rows="rows"
      :value="value"
      :required="required"
      :placeholder="placeholder"
      autocomplete="off"
      @input="$emit('input', $event.target.value)"
    ></textarea>
  </f-group>
</template>

<script>
import FGroup from './Base/FGroup'

export default {
  name: 'FTextarea',
  components: { FGroup },
  props: {
    value: { default: '' },
    label: String,
    id: { type: String, required: true },
    rows: { default: 3 },
    required: Boolean,
    placeholder: String,
    tooltip: String,
    error: { type: String, default: null }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormFields/FTextarea.vue